import { getGATrackingId } from '../../utils/analytics';
import { loadScriptInHeadImmediately } from '../../utils/dom';

export default (window) => {
  window.ga = window.ga||function(){(window.ga.q=window.ga.q||[]).push(arguments)};window.ga.l=+new Date; // eslint-disable-line
  loadScriptInHeadImmediately('skip', 'https://www.google-analytics.com/analytics.js');
  // });
// };

  /*
   * If the user has not consented, set up a cookieless tracker.
   * (A tracker with { storage: 'none' }).
   *
   * Then, if they accept cookies later, convert it to a
   * regular tracker (passing in the clientId generated by the
   * cookieless tracker).
   *
   */
  setupTrackerWithOptions(
    // { storage: 'none' } means it won't drop a cookie.
    { storage: 'none', allowLinker: true },
    window.ga
  );
}

function setupTrackerWithOptions(options, ga) {
  ga(
    'create',
    getGATrackingId(window.location.hostname),
    'auto',
    options
  );
  ga('set', 'anonymizeIp', true);
  ga('require', 'linker');
  ga(
    'linker:autoLink',
    ['refinery29.com', 'refinery29.de', 'refinery29.uk', 'madchatter.r29.com'],
    false,
    true
  );
}
